import axios from 'axios';
import { message } from '@/utils/element_message';
import router from '@/router';
import {
  getToken,
  removeToken,
  getFlashToken,
  setToken,
  setFlashToken,
} from '@/utils/auth';
import { getRefeshToken } from '@/api/login';
// import { setToken } from './auth'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://192.168.43.125:9099', //朱
  // baseURL: 'http://192.168.0.148:9099',  //硬
  // baseURL: 'http://192.168.0.103:9099',
  // baseURL:'http://192.168.0.226:9099',
  timeout: 30000,
});

service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = 'bearer' + token;
    } else {
      config.headers['Authorization'] = 'Basic Z2F0ZXdheTpnYXRld2F5=';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.data.code == 401) {
      removeToken();
      getRefeshToken({ refresh_token: getFlashToken() }).then((da) => {
        setToken(da.access_token);
        setFlashToken(da.refresh_token);
        location.reload();
      });
    } else {
      if (response.data.code !== 0 && response.data.code) {
        message({
          message: response.data.message,
          type: 'error',
          duration: 2 * 1000,
        });
      }
      return response.data;
    }
  },
  (error) => {
    switch (error.response.status) {
      case 401:
        let des = '';
        if (error.response.data.code.indexOf('Invalid refresh token') > -1) {
          des = '您的账号已经在异地登陆,请重新登录';
        } else {
          des = error.response.data.code;
        }
        message({
          message: des,
          type: 'error',
          duration: 5 * 1000,
        });
        router.push({ name: 'Login' });
        removeToken();
        break;
      default:
        break;
    }
    return Promise.reject(error.response.data);
  }
);
export default service;
